export default function (_this) {
  return {
    /**
     * Add new chart widget
     * @param {Object} data - data required
     */
    async add (data) {
      const widget = {
        template: '',
        gsOptions: {
          x: 0,
          y: 0,
          w: 12,
          h: 18
        },
        tab: data.tab
      }

      const widgetKey = await new Promise((resolve) => {
        const key = _this.getRef('widgets').push(widget, () => {
          resolve(key)
        }).key
      })

      const chartOptions = {
        type: data.defaultChartType
      }

      await new Promise((resolve) => {
        _this.getRef(`widgetsData/charts/${data.chartId}`)
          .set(chartOptions, (err) => {
            if (err) console.error(err)
            resolve()
          })
      })

      await new Promise((resolve) => {
        _this.getRef(`widgets/${widgetKey}/dependency`)
          .set(`charts/${data.chartId}`, () => (resolve()))
      })

      _this.getRef(`widgets/${widgetKey}/template`)
        .set(`<Chart chartId="${data.chartId}" :rData="${data.dataExp}" :widgetKey="widgetKey" />`)
    },
    /**
     * Read chart options
     * @param chartId - chart id
     */
    readOptions (chartId) {
      return new Promise((resolve) => {
        _this.getRef(`widgetsData/charts/${chartId}`).once('value', (snapshot) => {
          resolve(snapshot.val())
        })
      })
    },
    /**
     * Set default chart type
     * @param {string} chartId - chart id
     * @param {string} type - chart type
     */
    setActiveChartType (chartId, type) {
      _this.getRef(`widgetsData/charts/${chartId}/type`).set(type)
    },
    /**
     * Set data settings for chart
     * @param {string} newOptions - new chart options containing: lable1, label2, data
     */
    async setNewLablesAndData (chartId, newOptions) {
      const options = await new Promise((resolve) => {
        _this.getRef(`widgetsData/charts/${chartId}`).once('value', (snapshot) => {
          resolve(snapshot.val())
        })
      })

      const { label, data, label2 } = newOptions

      options.label = label || null
      options.data = data || null
      options.label2 = label2 || null

      _this.getRef(`widgetsData/charts/${chartId}`).set(options)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/db/chart.js